import { createSlice } from "@reduxjs/toolkit";
import {
    fetchDifficultyLevelTableColumnNames,
    fetchAllDifficultyLevel,
    createDifficultyLevel,
    updateDifficultyLevel,
    deleteDifficultyLevel,
    activateDeactivateDifficultyLevel
} from "./thunk";
import { toast } from "react-toastify";

const difficultyLevelSlice = createSlice({
  name: "DifficultyLevel",
  initialState: {
    difficultyLevel: [],
    tableColumnNames: [],
    loading: false,
    Headerload: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Difficulty Level Table Column Names
      .addCase(fetchDifficultyLevelTableColumnNames.pending, (state) => {
        state.Headerload = true;
        state.error = null;
      })
      .addCase(fetchDifficultyLevelTableColumnNames.fulfilled, (state, action) => {
        state.Headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchDifficultyLevelTableColumnNames.rejected, (state, action) => {
        state.Headerload = false;
        state.error = action.payload;
      })

      // Get All Difficulty Level
      .addCase(fetchAllDifficultyLevel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllDifficultyLevel.fulfilled, (state, action) => {
        state.loading = false;
        state.difficultyLevel = action.payload;
      })
      .addCase(fetchAllDifficultyLevel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Difficulty Level
      .addCase(createDifficultyLevel.pending, (state) => {
        state.error = null;
      })
      .addCase(createDifficultyLevel.fulfilled, (state, action) => {
        state.difficultyLevel = [action.payload.data[0], ...state.difficultyLevel];
      })
      .addCase(createDifficultyLevel.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Difficulty Level
      .addCase(updateDifficultyLevel.pending, (state) => {
        state.error = null;
      })
      .addCase(updateDifficultyLevel.fulfilled, (state, action) => {
        const index = state.difficultyLevel.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.difficultyLevel[index] = action.payload[0];
        }

      })
      .addCase(updateDifficultyLevel.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Difficulty Level
      .addCase(deleteDifficultyLevel.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteDifficultyLevel.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.difficultyLevel = state.difficultyLevel.filter(
          (item) => !deletedIds.includes(item.ID)
        );

      })
      .addCase(deleteDifficultyLevel.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Active Deactive Difficulty Level
      .addCase(activateDeactivateDifficultyLevel.pending, (state) => {
        state.error = null;
      })
      .addCase(activateDeactivateDifficultyLevel.fulfilled, (state, action) => {
        if (action.payload) {
          const updatedDifficultyLevel = action.payload[0];

          state.difficultyLevel = state.difficultyLevel.map((item) => item.ID === updatedDifficultyLevel.ID ? {...item, IsActive: updatedDifficultyLevel.IsActive} : item)
        }
      })
      .addCase(activateDeactivateDifficultyLevel.rejected, (state, action) => {
        state.error = action.payload;
      })
    },
});

export default difficultyLevelSlice.reducer;